<template>
  <custom-callout
    class="mb-3"
    controlled
    :has-toggle="false"
    :has-border="false"
    :opened="item.selected"
  >
    <div class="row m-0 d-flex align-items-center py-2">
      <div class="col-md col-12 mb-lg-0 border-right">
        <div class="color-secondary-6 font-14 font-weight-normal">
          Nombre del Material/Equipo:
        </div>
        <div class="color-black font-16 font-weight-normal text-break">
          {{ item.name | empty }}
        </div>
      </div>
      <div class="col-md col-12 mb-lg-0">
        <div class="color-secondary-6 font-14 font-weight-normal">
          Categoría:
        </div>
        <div class="color-black font-16 font-weight-normal text-break">
          {{ item.category.name | empty }}
        </div>
      </div>
      <div class="col">
        <action-button
          class="float-md-right mr-2"
          i="far fa-check"
          :text="item.selected ? 'Seleccionado' : 'Seleccionar'"
          :variant="
            item.selected
              ? 'success'
              : item.disabled
              ? 'outline-secondary'
              : 'outline-success'
          "
          :disabled="item.disabled"
          @click="select"
        />
      </div>
    </div>
    <template #edition>
      <div class="mx-4 p-2">
        <div class="mb-2">
          <inner-page-message
            is-html
            :visible="isAlertVisible"
            :message="alertMessage"
          />
        </div>
        <validation-observer ref="form" novalidate>
          <div class="row mb-1">
            <div class="col-md col-12">
              <validation-provider
                mode="eager"
                rules="required"
                v-slot="{ errors }"
              >
                <custom-drop-down
                  v-model="model.reason"
                  :options="catalogs.reasons"
                  label="Razón:"
                  fieldkey="id"
                  fieldname="name"
                  placeholder="Seleccione"
                  class="w-100 bold-label"
                  custom-error-msg="Este campo es requerido"
                  :error="errors[0]"
                  @input="onReasonChange()"
                />
              </validation-provider>
            </div>
            <div class="col-md col-12">
              <validation-provider
                mode="eager"
                rules="required"
                v-slot="{ errors }"
              >
                <custom-drop-down
                  v-model="model.saloonType"
                  :options="catalogs.saloonTypes"
                  label="Tipo de Salón:"
                  fieldkey="id"
                  fieldname="name"
                  placeholder="Seleccione"
                  class="w-100 bold-label"
                  custom-error-msg="Este campo es requerido"
                  :error="errors[0]"
                  @input="exist"
                />
              </validation-provider>
            </div>
            <div class="col-md col-12">
              <div
                v-if="isAsignStudentReasonSelected"
                class="d-flex flex-row justify-content-between"
              >
                <div class="w-75">
                  <custom-input
                    v-model="sieInput"
                    type="number"
                    class="w-100"
                    label="SIE del Estudiante:"
                    placeholder="Escriba Número de SIE"
                    icon="fas fa-search text-orange"
                    left-icon
                  />
                </div>
                <div class="d-flex align-items-end justify-content-end">
                  <action-button
                    i="fas fa-file-plus"
                    text="Añadir"
                    :variant="
                      canAddStudent && !loadingStudent ? 'success' : 'secondary'
                    "
                    :disabled="loadingStudent || !canAddStudent"
                    @click="addStudent"
                  />
                </div>
              </div>
              <validation-provider
                v-else
                mode="eager"
                rules="required|integer"
                v-slot="{ errors }"
              >
                <custom-input
                  v-model="model.quantity"
                  type="number"
                  class="w-100"
                  custom-error-msg="Este campo es requerido"
                  :error="errors[0]"
                  label="Cantidad de Material/Equipo a Solicitar:"
                />
              </validation-provider>
            </div>
            <div class="w-100 my-1"></div>
            <div v-if="!isMaster" class="col-md col-12">
              <validation-provider
                mode="eager"
                rules="required"
                v-slot="{ errors }"
              >
                <custom-drop-down
                  v-model="model.center"
                  :options="catalogs.centers"
                  label="Centro:"
                  fieldkey="id"
                  fieldname="name"
                  placeholder="Seleccione"
                  class="w-100 bold-label"
                  custom-error-msg="Este campo es requerido"
                  :error="errors[0]"
                  @input="onChangeCenter"
                />
              </validation-provider>
            </div>
            <div v-if="!isMaster" class="col-md col-12">
              <validation-provider
                mode="eager"
                rules="required"
                v-slot="{ errors }"
              >
                <custom-drop-down
                  v-model="model.municipality"
                  :options="catalogs.municipalities"
                  label="Municipio:"
                  fieldkey="id"
                  fieldname="name"
                  placeholder="Seleccione"
                  class="w-100  bold-label"
                  custom-error-msg="Este campo es requerido"
                  :error="errors[0]"
                  :disabled="!model.center"
                  @input="onChangeMunicipality"
                />
              </validation-provider>
            </div>
            <div v-if="!isMaster" class="col-md col-12">
              <validation-provider
                mode="eager"
                rules="required"
                v-slot="{ errors }"
              >
                <custom-drop-down
                  v-model="model.school"
                  :options="catalogs.schools"
                  label="Escuela:"
                  fieldkey="id"
                  fieldname="name"
                  placeholder="Seleccione"
                  class="w-100 bold-label"
                  custom-error-msg="Este campo es requerido"
                  :error="errors[0]"
                  :disabled="!model.municipality"
                />
              </validation-provider>
            </div>
            <div class="w-100 my-1"></div>
            <div v-if="!isMaster" class="col-md col-12 pl-0">
              <validation-provider
                mode="eager"
                rules="required"
                v-slot="{ errors }"
              >
                <custom-radio-button
                  v-model="model.schoolBelongsTo"
                  name="schoolBelongsTo"
                  label="Escuela pertenece a:"
                  :options="radioButtonsOptionsSchoolBelongsTo"
                  is-inline
                  :error="errors[0]"
                  custom-error-msg="Este campo es requerido"
                  :is-disabled="false"
                />
              </validation-provider>
            </div>
            <div v-if="!isMaster" class="col-md col-12">
              <validation-provider
                mode="eager"
                rules="required"
                v-slot="{ errors }"
              >
                <custom-radio-button
                  v-model="model.hasPreviouslySubmitted"
                  name="hasPreviouslySubmitted"
                  label="¿Han sometido cartas solicitando reparaciones o instalaciones anteriormente?"
                  :options="radioButtonsOptionsLetters"
                  is-inline
                  :error="errors[0]"
                  custom-error-msg="Este campo es requerido"
                  :is-disabled="false"
                />
              </validation-provider>
            </div>
            <div v-if="!isMaster" class="col-md col-12">
              <validation-provider
                mode="eager"
                rules="required"
                v-slot="{ errors }"
              >
                <custom-radio-button
                  v-model="model.isComplaintRequest"
                  name="isComplaintRequest"
                  label="¿La solicitud es por una querella?"
                  :options="radioButtonsOptionsComplaint"
                  is-inline
                  :error="errors[0]"
                  custom-error-msg="Este campo es requerido"
                  :is-disabled="false"
                />
              </validation-provider>
            </div>
            <div class="w-100 my-1"></div>
            <div v-if="!isMaster" class="col-md col-12 pl-0">
              <validation-provider
                mode="eager"
                rules="required"
                v-slot="{ errors }"
              >
                <custom-radio-button
                  v-model="model.isNewCreationRequest"
                  name="isNewRequest"
                  label="¿La escuela es de nueva creación?"
                  :options="radioButtonsOptionsNewRequest"
                  is-inline
                  :error="errors[0]"
                  custom-error-msg="Este campo es requerido"
                  :is-disabled="false"
                />
              </validation-provider>
            </div>
            <div class="w-100 my-1"></div>
            <div v-if="!isMaster" class="col-12">
              <documents
                :documents="model.documents"
                :document-types="catalogs.documentTypes"
              />
            </div>
            <div class="w-100 my-1"></div>
            <div class="col-12">
              <validation-provider
                mode="eager"
                rules="required"
                v-slot="{ errors }"
              >
                <custom-text-area
                  label="Comentario:"
                  v-model="model.comment"
                  :count-classes="['d-block', 'small-counter', 'text-right']"
                  custom-error-msg="Este campo es requerido"
                  :error="errors[0]"
                  :maxlength="3000"
                  placeholder="Escriba un comentario"
                  show-char-count
                />
              </validation-provider>
            </div>
            <div v-if="isPlanningNextYearReasonSelected" class="col-12 mb-3">
              <div class="d-flex flex-row justify-content-between">
                <div class="flex-fill pr-4">
                  <custom-input
                    v-model="sieInput"
                    type="number"
                    class="w-100"
                    label="SIE del Estudiante:"
                    placeholder="Escriba Número de SIE"
                    icon="fas fa-search text-orange"
                    left-icon
                  />
                </div>
                <div class="d-flex align-items-end justify-content-end">
                  <action-button
                    id="btnSave"
                    i="fas fa-file-plus"
                    text="Añadir"
                    :variant="
                      canAddStudent && !loadingStudent ? 'success' : 'secondary'
                    "
                    :disabled="loadingStudent || !canAddStudent"
                    @click="addStudent"
                  />
                </div>
              </div>
            </div>
            <div v-if="hasStudentsSelected" class="col-12 my-1">
              <icon-view
                icon="fas fa-user-circle fa-lg text-orange"
                :title="
                  isAsignStudentReasonSelected
                    ? 'Estudiante Seleccionado'
                    : 'Estudiante(s) Seleccionado(s)'
                "
                variant="custom-icon-view"
                icon-background="white"
              />
              <div
                class="my-3 px-3"
                v-for="(student, sKey) in model.students"
                :key="sKey"
              >
                <div
                  class="row font-weight-normal p-3 bg-white rounded border-left-4"
                >
                  <div class="col-md-3 col-12">
                    <div class="color-secondary-6 font-14">
                      Nombre del Estudiante:
                    </div>
                    <div class="color-black font-16 text-break">
                      {{ student.fullName | empty }}
                    </div>
                  </div>
                  <div class="col-md col-12">
                    <div class="color-secondary-6 font-14">
                      SIE:
                    </div>
                    <div class="color-black font-16 text-break">
                      {{ student.studentId | empty }}
                    </div>
                  </div>
                  <div class="col-md col-12">
                    <div class="color-secondary-6 font-14">
                      Edad:
                    </div>
                    <div class="color-black font-16 text-break">
                      {{ `${student.age}`.split('.')[0] | empty }}
                    </div>
                  </div>
                  <div class="col-md-3 col-12">
                    <div class="color-secondary-6 font-14">
                      Impedimento:
                    </div>
                    <div class="color-black font-16 text-break">
                      {{ student.impediment | empty }}
                    </div>
                  </div>
                  <div class="col-md col-12">
                    <div class="color-secondary-6 font-14">
                      Estatus:
                    </div>
                    <div class="color-black font-16 text-break">
                      {{ student.status | empty }}
                    </div>
                  </div>
                  <div
                    class="col-md-1 col-12 d-flex align-items-center justify-content-end"
                  >
                    <action-button
                      i="fas fa-times-circle"
                      variant="outline-danger"
                      @click="quitStudent(sKey)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-end my-3 mt-md-0">
            <div :class="{ 'w-100 mb-2': isMobile }">
              <action-button
                id="btnCancel"
                i="fas fa-times-circle"
                text="Cancelar"
                :variant="`outline-danger mr-2 ${isMobile ? 'w-100' : 'mt-2'}`"
                @click="cancel"
              />
            </div>
            <div :class="{ 'w-100': isMobile }">
              <action-button
                id="btnSave"
                i="fas fa-file-plus"
                text="Guardar"
                :variant="`success ${isMobile ? 'w-100' : 'mt-2'}`"
                @click="save"
              />
            </div>
          </div>
        </validation-observer>
      </div>
    </template>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import CustomTextArea from 'CustomTextArea';
import CustomInput from 'CustomInput';
import CustomRadioButton from 'custom-radio';
import IconView from 'icon-view';
import InnerPageMessage from '@/components/common/page/InnerPageMessage.vue';
import Documents from './Documents.vue';

import alertMixin from '@/mixin/alert.mixin';
import objectToFormData from 'object-to-formdata';

import inventoryOrderMaterialsAndEquipmentsService from '@/services/api/inventoryOrderMaterialsAndEquipments.api';
import studentService from '@/services/student.js';

import OrderReasons from '@/utils/constants/inventory/inventoryMaterialEquipmentOrderReasons.js';
import StudentStatuses from '@/utils/constants/student/studentStatuses.js';
import userRole from '@/utils/constants/userRoles';
import schoolMembership from '@/utils/constants/pei/materials-equipment/schoolMembership.js';

const documentTypes = {
  COTIZACION: 228,
  QUERELLA: 227,
  OTRO: 229,
};

export default {
  name: 'ResultRow',
  mixins: [alertMixin],
  components: {
    CustomCallout,
    ActionButton,
    CustomDropDown,
    CustomTextArea,
    CustomInput,
    CustomRadioButton,
    IconView,
    InnerPageMessage,
    Documents,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    catalogs: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      sieInput: '',
      loadingStudent: false,
      alertMessage: null,
      isAlertVisible: false,
      model: {
        reason: null,
        saloonType: null,
        quantity: null,
        center: null,
        municipality: null,
        school: null,
        students: [],
        schoolBelongsTo: null,
        hasPreviouslySubmitted: null,
        isComplaintRequest: null,
        isNewCreationRequest: null,
        documents: [],
      },
      radioButtonsOptionsSchoolBelongsTo: [
        { label: 'Omep', value: schoolMembership.Omep },
        {
          label: 'Edificios Públicos',
          value: schoolMembership.EdificiosPublicos,
        },
      ],
      radioButtonsOptionsLetters: [
        { label: 'Sí', value: true },
        { label: 'No', value: false },
      ],
      radioButtonsOptionsComplaint: [
        { label: 'Sí', value: true },
        { label: 'No', value: false },
      ],
      radioButtonsOptionsNewRequest: [
        { label: 'Sí', value: true },
        { label: 'No', value: false },
      ],
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    isMaster() {
      return [userRole.maestro, userRole.maestroPrivado].includes(
        this.userRole
      );
    },
    isPlanningNextYearReasonSelected() {
      return this.model.reason?.id === OrderReasons.PlanningNextSchoolYear;
    },
    isAsignStudentReasonSelected() {
      return this.model.reason?.id === OrderReasons.AssignStudent;
    },
    canAddStudent() {
      const isValidSie =
        this.sieInput?.length === 8 && Number.isInteger(Number(this.sieInput));

      const maxStudentSelected = this.isPlanningNextYearReasonSelected
        ? this.model.quantity > 0 &&
          this.model.students.length >= this.model.quantity
        : this.hasStudentsSelected;

      const validRules = [isValidSie, !maxStudentSelected];
      return validRules.every((x) => x);
    },
    hasStudentsSelected() {
      return this.model.students.length > 0;
    },
  },
  methods: {
    select() {
      this.item.selected = !this.item.selected;
      this.$emit('toggle', this.item);
    },
    async onReasonChange() {
      this.model = {
        ...this.model,
        saloonType: null,
        comment: null,
        quantity: null,
        center: null,
        municipality: null,
        school: null,
        students: [],
      };
    },
    onChangeCenter(val) {
      this.model.municipality = null;
      this.model.school = null;
      this.$emit('center', val?.id);
    },
    onChangeMunicipality(val) {
      this.model.school = null;
      this.$emit('municipality', this.model.center.id, val?.id);
    },
    async addStudent() {
      if (!this.canAddStudent) return;

      if (this.isPlanningNextYearReasonSelected && this.model.quantity < 1) {
        this.ShowToast(
          'Error',
          'Se debe documentar la cantidad de material/equipo(s) a solicitar.',
          'error'
        );
        return;
      }

      if (this.model.students.some((x) => x.studentId == this.sieInput)) {
        this.ShowToast(
          'Error',
          'El estudiante se encuentra registrado.',
          'error'
        );
        return;
      }

      this.loadingStudent = true;
      try {
        const { data } = await studentService.getBySie(this.sieInput);
        if (!data.canAccess) throw new Error(this.catalogs.resources['44']);

        if (data.statusId !== StudentStatuses.Servido)
          throw new Error('El estudiante debe estar en el estatus de Servido.');

        this.model.students.push(data);
        this.sieInput = null;
        this.loadingStudent = false;
      } catch (error) {
        this.ShowToast(
          'Error',
          error?.message ?? error?.response?.data?.message,
          'error'
        );
        this.loadingStudent = false;
      }
    },
    quitStudent(index) {
      this.model.students.splice(index, 1);
    },
    async exist() {
      this.isAlertVisible = false;

      if (!this.model.saloonType?.id) return;
      const { data } = await inventoryOrderMaterialsAndEquipmentsService.exist({
        catalogId: this.item.id,
        categoryId: this.item.category.id,
        saloonTypeId: this.model.saloonType.id,
      });
      this.isAlertVisible = data;
      if (data)
        this.alertMessage = `Material/Equipo disponible por las entregas del año académico anterior: “Según los criterios solicitados, la escuela cuenta con el Material/Equipo disponible del año académico anterior” ¿Desea proceder con esta solicitud?`;
    },
    clear() {
      this.model = {
        reason: null,
        saloonType: null,
        quantity: null,
        center: null,
        municipality: null,
        school: null,
        schoolBelongsTo: null,
        hasPreviouslySubmitted: null,
        isComplaintRequest: null,
        isNewCreationRequest: null,
        documents: [],
        students: [],
      };
      this.sieInput = '';
    },
    cancel() {
      this.clear();
      this.select();
    },
    async save() {
      const valid = await this.$refs.form.validate();
      if (!valid) {
        this.ShowToast(
          'Error',
          'Favor de completar la información solicitada.',
          'error'
        );
        return;
      }

      if (this.isAsignStudentReasonSelected && this.model.students.length < 1) {
        this.ShowToast(
          'Error',
          'Favor de seleccionar al menos un estudiante.',
          'error'
        );
        return;
      }

      if (
        this.isPlanningNextYearReasonSelected &&
        Number(this.model.quantity) < this.model.students.length
      ) {
        this.ShowToast(
          'Error',
          'La cantidad de estudiantes seleccionados es mayor a la cantidad de material/equipo(s) a solicitar, favor de remover los estudiantes.',
          'error'
        );
        return;
      }

      if (
        this.model.isComplaintRequest &&
        !this.model.documents.some(
          (d) => d.type?.id === documentTypes.QUERELLA && d.file !== null
        )
      ) {
        this.ShowToast(
          'Error',
          'El Documento de Querella es requerido.',
          'error'
        );
        return;
      }

      if (this.model.documents.some((d) => d.file === null)) {
        this.ShowToast(
          'Error',
          'Los documentos seleccionados deben estar anejados.',
          'error'
        );
        return;
      }

      const confirmed = await this.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea guardar la información documentada?',
        'Si',
        'No'
      );
      if (!confirmed) return;

      try {
        const params = objectToFormData(
          {
            catalogId: this.item.id,
            categoryId: this.item.category.id,
            reasonId: this.model.reason.id,
            saloonTypeId: this.model.saloonType.id,
            quantity: this.model.quantity ? Number(this.model.quantity) : 1,
            centerId: this.model.center?.id,
            municipalityId: this.model.municipality?.id,
            schoolId: this.model.school?.id,
            comment: this.model.comment,
            students: this.model.students.map((r) => ({
              studentSieId: r.studentId,
            })),
            schoolBelongsTo: this.model.schoolBelongsTo,
            hasPreviouslySubmitted: this.model.hasPreviouslySubmitted,
            isComplaintRequest: this.model.isComplaintRequest,
            isNewCreationRequest: this.model.isNewCreationRequest,
          },
          { indices: true }
        );
        if (this.model.documents.length) {
          this.model.documents.forEach((document, index) => {
            params.append(`documents[${index}].file`, document.file);
            params.append(`documents[${index}].fileName`, document.file?.name);
            params.append(
              `documents[${index}].documentTypeId`,
              document.type?.id
            );
            params.append(`documents[${index}].date`, new Date().toISOString());
          });
        }
        await inventoryOrderMaterialsAndEquipmentsService.save(params);
        this.cancel();
        this.ShowToast(
          'Éxito',
          'La solicitud se ha guardada correctamente.',
          'success'
        );
        this.$emit('selected', this.item);
      } catch (error) {
        this.ShowToast(
          'Error',
          'Ha ocurrido un error al guardar la solicitud.',
          'error'
        );
      }
    },
  },
};
</script>
<style scoped lang="scss">
@use "sass:map";
@import '@/assets/scss/variables/_colors.scss';

::v-deep .ab-btn-success {
  color: map.get($colors, 'white') !important;
  background-color: map.get($colors, 'green') !important;
  border-color: map.get($colors, 'green') !important;
}
::v-deep .text-disabled {
  color: #b5c3bc !important;
}
</style>
